import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromSpecialOffersActions from '../actions/special-offers.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {WebshopRestService} from '../../services/api/webshop-rest.service';
import {ProductsResponse} from '../../models/shop/products-response.model';
import {ProductType} from '../../models/shop/product-type.model';

@Injectable()
export class SpecialOffersEffects {
    private actions$ = inject(Actions);
    private productRestService = inject(WebshopRestService);
    /**
     * In case of SearchInvoicesAction we're going to call the InvoicesService and then
     * we'll post a LoadInvoicesCompleteAction to the reducer or in case of failure
     * LoadInvoicesFailAction
     *
     * @type {Observable<any>}
     */
    loadSpecialOffers$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromSpecialOffersActions.LoadSpecialOffersAction>(
                fromSpecialOffersActions.SpecialOffersActionTypes.LOAD_PIN
            ),
            map(action => action.payload),
            switchMap(productRequest =>
                this.productRestService.loadSpecialOffers(productRequest).pipe(
                    switchMap(data => {
                        const prodResp = new ProductsResponse({
                            ...data.returnObject,
                            ...{ type: ProductType.OffersPin }
                        });
                        if (productRequest.page === 1) {
                            return [
                                new fromSpecialOffersActions.LoadSpecialOffersCompleteAction(prodResp),
                                new fromSpecialOffersActions.GetBatchFromCacheAction()
                            ];
                        } else {
                            return [new fromSpecialOffersActions.LoadSpecialOffersCompleteAction(prodResp)];
                        }
                    }),
                    catchError(error => of(new fromSpecialOffersActions.LoadSpecialOffersFailAction(error)))
                )
            )
        )
    );

    searchSpecialOffers$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromSpecialOffersActions.SearchShopAction>(
                fromSpecialOffersActions.SpecialOffersActionTypes.SEARCH_PIN
            ),
            map(action => action.payload),
            switchMap(productRequest => [
                new fromSpecialOffersActions.LoadSpecialOffersAction(productRequest)
            ])
        )
    );

}